import gql from 'graphql-tag';

export const getCommercialOperatingAreas = gql`
  query getCommercialOperatingAreas {
    getCommercialOperatingAreas {
      id
      name
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
    }
  }
`;

export const getCommercialMarketAreas = gql`
  query getCommercialMarketAreas($operatingAreaId: ID) {
    getCommercialMarketAreas(operatingAreaId: $operatingAreaId) {
      id
      name
      operatingAreaId
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
    }
  }
`;

export const getCommercialFacilityTypes = gql`
  query getCommercialFacilityTypes {
    getCommercialFacilityTypes {
      id
      name
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
    }
  }
`;

export const getCommercialBalancingTypes = gql`
  query getCommercialBalancingTypes {
    getCommercialBalancingTypes {
      id
      name
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
    }
  }
`;

export const getCommercialCompanies = gql`
  query getCommercialCompanies {
    getCommercialCompanies {
      id
      name
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
    }
  }
`;
